module.exports = __webpack_public_path__ + "bean.png?5124fac6ce3906003e6cbf45770987e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bean.png
// module id = 43
// module chunks = 0